var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-overlay',{staticClass:"position-fixed",staticStyle:{"z-index":"999999"},attrs:{"show":_vm.$store.state.loading,"spinner-variant":"primary","rounded":"lg","no-wrap":""}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }